import { getPersistedCartData } from "@/cart/lib/persisted-data";
import { publishShoppingCartViewEvent as publishCartView } from "@/cart/lib/acdl";
import { state } from "@/cart/lib/state";

export const publishShoppingCartViewEvent = () => { 
  const locale = state.locale ?? 'en-US';
  const cartData = getPersistedCartData();

  if (!cartData) {
    return;
  }

  // Publish the event
  publishCartView(cartData, locale);
}
